import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { isTokenExpired, refreshToken } from './utils/auth'; // Utility functions
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SubmissionDetails from './components/Dashboard/SubmissionDetails';
import './index.css';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const validateToken = async () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken || isTokenExpired(accessToken)) {
      try {
        const newAccessToken = await refreshToken(); // Refresh the token
        console.log('Token refreshed successfully');
        setIsAuthenticated(true);
      } catch (err) {
        console.error('Token validation failed:', err.message);
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(true); // Token is valid
    }
    setLoading(false); // Stop loading
  };

  useEffect(() => {
    validateToken(); // Validate token on app load
  }, []);

  if (loading) return <p>Loading...</p>; // Show a loading screen while validating token

  return (
    <Router>
      <Routes>
        {/* Login Route */}
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" />
            ) : (
              <LoginPage onLogin={() => setIsAuthenticated(true)} />
            )
          }
        />

        {/* Dashboard Route */}
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <DashboardPage onLogout={() => setIsAuthenticated(false)} />
            ) : (
              <Navigate to="/" />
            )
          }
        />

        {/* Submission Details Route */}
        <Route
          path="/submissions/:submissionId"
          element={
            isAuthenticated ? (
              <SubmissionDetails />
            ) : (
              <Navigate to="/" />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
